import axios,{buildApi} from "@/libs/api.request";

export const apis = buildApi({
	get:['/rule/miscellaneous/index&list','/rule/miscellaneous/conf','/rule/miscellaneous/select/:client_id&select'],
	post:['/rule/miscellaneous/save','/rule/miscellaneous/delete/:id&del']
})